import { render, staticRenderFns } from "./VendorData.vue?vue&type=template&id=677ae988&scoped=true&"
import script from "./VendorData.vue?vue&type=script&lang=ts&"
export * from "./VendorData.vue?vue&type=script&lang=ts&"
import style0 from "./VendorData.vue?vue&type=style&index=0&id=677ae988&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677ae988",
  null
  
)

export default component.exports